export default (phoneNumber) => {
    // 999-999-9999
    if (!phoneNumber) {
        return '';
    }

    const [_, p1, p2, p3] = phoneNumber.match(/(\d?\d?\d?)(\d?\d?\d?)(\d?\d?\d?\d?)/);

    let masked = '';

    if (p1) {
        masked += p1;
    }

    if (p2) {
        masked += '-' + p2;
    }

    if (p3) {
        masked += '-' + p3;
    }

    return masked;
};
